export const PDF_PRINT_IFRAME_ID = 'pdf-content-print';
export const REACT_TO_PRINT_IFRAME_ID = 'printWindow';
